import React from 'react'
import { AccountNav } from './AccountNav';

export const PrescriptionsPage = () => {
  return (
    <div className="container mx-auto md:flex grid grid-cols-1 gap-8 px-9 my-12">
      <AccountNav />

      <div className="lg:w-3/4 md:w-2/3 min-h-[400px]">
        <h1 className="text-sm font-light mb-4">My Saved Prescriptions</h1>
        
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-5">
          <div className="border bg-sky-50 py-10 px-4">
            <div className="font-medium uppercase text-sm leading-7">
              <h3>NAME: SURINDER Kumar</h3>
              <h3>POWER TYPE: SINGLE VISION</h3>
            </div>
            <p className="text-sm font-light mt-1">Created Sat Apr 16 2022</p>
            <div className="grid grid-cols-3 uppercase gap-1 bg-white p-[2px] text-white text-center font-light text-[11px] tracking-widest">
              <div className="bg-gray-800 py-2">Eye</div>
              <div className="bg-gray-800 py-2">RIGHT EYE</div>
              <div className="bg-gray-800 py-2">LEFT EYE</div>
              <div className="bg-gray-800 py-2">SPHERICAL</div>
              <div className="bg-slate-100 py-2 text-gray-800">0.00</div>
              <div className="bg-slate-100 py-2 text-gray-800">-0.25</div>
              <div className="bg-gray-800 py-2">CYLINDRICAL</div>
              <div className="bg-slate-100 py-2 text-gray-800">-2.00</div>
              <div className="bg-slate-100 py-2 text-gray-800">-0.50</div>
              <div className="bg-gray-800 py-2">AXIS</div>
              <div className="bg-slate-100 py-2 text-gray-800">65</div>
              <div className="bg-slate-100 py-2 text-gray-800">100</div>
              <div className="bg-gray-800 py-2">AP</div>
              <div className="bg-slate-100 py-2 text-gray-800">--</div>
              <div className="bg-slate-100 py-2 text-gray-800">--</div>
            </div>
          </div>

          <div className="border bg-sky-50 py-10 px-4">
            <div className="font-medium uppercase text-sm leading-7">
              <h3>NAME: SURINDER Kumar</h3>
              <h3>POWER TYPE: SINGLE VISION</h3>
            </div>
            <p className="text-sm font-light mt-1">Created Sat Apr 16 2022</p>
            <div className="grid grid-cols-3 uppercase gap-1 bg-white p-[2px] text-white text-center font-light text-[11px] tracking-widest">
              <div className="bg-gray-800 py-2">Eye</div>
              <div className="bg-gray-800 py-2">RIGHT EYE</div>
              <div className="bg-gray-800 py-2">LEFT EYE</div>
              <div className="bg-gray-800 py-2">SPHERICAL</div>
              <div className="bg-slate-100 py-2 text-gray-800">0.00</div>
              <div className="bg-slate-100 py-2 text-gray-800">-0.25</div>
              <div className="bg-gray-800 py-2">CYLINDRICAL</div>
              <div className="bg-slate-100 py-2 text-gray-800">-2.00</div>
              <div className="bg-slate-100 py-2 text-gray-800">-0.50</div>
              <div className="bg-gray-800 py-2">AXIS</div>
              <div className="bg-slate-100 py-2 text-gray-800">65</div>
              <div className="bg-slate-100 py-2 text-gray-800">100</div>
              <div className="bg-gray-800 py-2">AP</div>
              <div className="bg-slate-100 py-2 text-gray-800">--</div>
              <div className="bg-slate-100 py-2 text-gray-800">--</div>
            </div>
          </div>

        </div>

      </div>

    </div>
  )
}
